import { render, staticRenderFns } from "./JenisPerundangan.vue?vue&type=template&id=22ed4ffc"
import script from "./JenisPerundangan.vue?vue&type=script&lang=js"
export * from "./JenisPerundangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports